import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';

import { gqlRequest } from '../../helpers/request';
import { getFavoritesAction, setFavoritesAction } from '../slices/common';

const queryGQL = `
  query hostedWatchGetFavorites {
    hostedWatchGetFavorites
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(getFavoritesAction.type),
    mergeMap(() =>
      gqlRequest({ query: queryGQL }).pipe(
        map(({ data, errors }) => setFavoritesAction(!errors.length ? data.hostedWatchGetFavorites : [])),
      ),
    ),
  );
